// illCurrency quick add: the + on a product card opens a size picker (garment, fit, size), adds one item and opens the cart.
// No size is picked for the shopper. Products with several colors go to the product page instead.
(() => {
  if (window.illQuickAddReady) return;
  window.illQuickAddReady = true;

  const FITS = ['Mens', 'Womens', 'Womans', 'Kids'];
  const SHORT = {
    'X-Small': 'XS', Small: 'S', Medium: 'M', Large: 'L', 'X-Large': 'XL', '2X-Large': '2XL', 'XX-Large': '2XL',
    '3X-Large': '3XL', 'XXX-Large': '3XL', '4X-Large': '4XL', '5X-Large': '5XL', '24 Months': '24M'
  };
  const cache = new Map();
  const getProduct = (handle) => {
    if (!cache.has(handle)) {
      const p = fetch(`${window.Shopify?.routes?.root || '/'}products/${handle}.js`)
        .then((r) => { if (!r.ok) throw new Error(`product ${r.status}`); return r.json(); });
      p.catch(() => cache.delete(handle));
      cache.set(handle, p);
    }
    return cache.get(handle);
  };
  const money = (cents) => (window.Shopify && Shopify.formatMoney
    ? Shopify.formatMoney(cents, window.money_format)
    : `$${(cents / 100).toFixed(2)}`);
  const fitLabel = (f) => (f === 'Womans' ? 'Womens' : f);
  const sizeLabel = (s) => SHORT[s] || s;

  const build = (p) => {
    const roles = { size: -1, fit: -1, garment: -1 };
    const fixed = [];
    p.options.forEach((o, i) => {
      const n = (o.name || '').toLowerCase().trim();
      if (n.includes('size')) roles.size = i;
      else if (n === 'fit') roles.fit = i;
      else if (n.includes('garment') || n === 'product type' || n === 'type') roles.garment = i;
      else fixed.push(i);
    });
    if (roles.size < 0) return null;
    if (fixed.some((i) => p.options[i].values.length > 1)) return null;
    const val = (v, i) => v[`option${i + 1}`];
    const pfit = roles.fit < 0 && p.variants.some((v) => FITS.includes((val(v, roles.size) || '').split(' ')[0]));
    const fitOf = (v) => (roles.fit >= 0 ? val(v, roles.fit) : pfit ? val(v, roles.size).split(' ')[0] : '');
    const sizeOf = (v) => (pfit ? val(v, roles.size).slice(val(v, roles.size).indexOf(' ') + 1) : val(v, roles.size));
    const live = p.variants.filter((v) => v.available);
    if (!live.length) return null;
    let open = live[0];
    if (fitOf(open) && fitOf(open) !== 'Mens') {
      const mens = live.filter((v) => fitOf(v) === 'Mens');
      open = mens.find((v) => roles.garment < 0 || val(v, roles.garment) === val(open, roles.garment)) || mens[0] || open;
    }
    return { p, roles, val, pfit, fitOf, sizeOf, live, open };
  };

  let dlg;
  let state;
  const sheet = () => {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ill-qa-sheet';
    dlg.setAttribute('aria-labelledby', 'ill-qa-title');
    dlg.innerHTML = `
      <div class="ill-qa__inner">
        <div class="ill-qa__head">
          <img class="ill-qa__img" alt="" width="64" height="64">
          <div><p class="ill-qa__title" id="ill-qa-title"></p><p class="ill-qa__price"></p></div>
          <button type="button" class="ill-qa__x" aria-label="Close">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>
          </button>
        </div>
        <div class="ill-qa__groups"></div>
        <p class="ill-qa__err" role="alert" hidden></p>
        <button type="button" class="btn ill-qa__add"></button>
        <a class="ill-qa__more" href="#">See full details</a>
      </div>`;
    document.body.appendChild(dlg);
    dlg.querySelector('.ill-qa__x').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', () => document.documentElement.classList.remove('ill-qa-open'));
    dlg.querySelector('.ill-qa__groups').addEventListener('click', onPick);
    dlg.querySelector('.ill-qa__add').addEventListener('click', onAdd);
    return dlg;
  };

  const matches = (v, s, skip) => {
    const { roles, val, fitOf, sizeOf } = s.m;
    if (skip !== 'garment' && roles.garment >= 0 && val(v, roles.garment) !== s.garment) return false;
    if (skip !== 'fit' && fitOf(v) !== s.fit) return false;
    if (skip !== 'size' && s.size != null && sizeOf(v) !== s.size) return false;
    return true;
  };
  const uniq = (arr) => [...new Set(arr)];
  const current = () => (state.size == null ? null : state.m.live.find((v) => matches(v, state)));

  const render = () => {
    const { m } = state;
    const groups = [];
    if (m.roles.garment >= 0) {
      const values = uniq(m.live.map((v) => m.val(v, m.roles.garment)));
      if (values.length > 1) {
        const words = values.map((g) => /sweatshirt|crewneck/i.test(g) ? 'Sweatshirt' : /hoodie/i.test(g) ? 'Hoodie' : /\bt-?shirt\b|\btee\b/i.test(g) ? 'Tee' : g);
        const dupes = new Set(words).size < words.length;
        groups.push({ key: 'garment', label: 'Garment', cls: '', items: values.map((g, i) => [g, dupes ? g.replace('T-Shirt', 'Tee') : words[i]]) });
      }
    }
    const fits = uniq(m.live.filter((v) => matches(v, { ...state, size: null }, 'fit')).map(m.fitOf)).filter(Boolean);
    const fitOrder = FITS.filter((f) => fits.includes(f)).concat(fits.filter((f) => !FITS.includes(f)));
    if (fitOrder.length > 1) groups.push({ key: 'fit', label: 'Fit', cls: '', items: fitOrder.map((f) => [f, fitLabel(f)]) });
    const sizes = uniq(m.live.filter((v) => matches(v, { ...state, size: null })).map(m.sizeOf));
    groups.push({ key: 'size', label: state.size == null ? 'Size · pick your size' : 'Size', cls: ' ill-qa__opts--size', items: sizes.map((s) => [s, sizeLabel(s)]) });

    dlg.querySelector('.ill-qa__groups').innerHTML = groups.map((g) => `
      <div class="ill-qa__grp" role="group" aria-labelledby="ill-qa-l-${g.key}" data-grp="${g.key}">
        <p class="ill-qa__lbl" id="ill-qa-l-${g.key}">${g.label}</p>
        <div class="ill-qa__opts${g.cls}">
          ${g.items.map(([value, text]) => `<button type="button" class="ill-qa__opt" data-key="${g.key}" data-value="${value.replace(/"/g, '&quot;')}" aria-pressed="${state[g.key] === value}"${g.key === 'size' && text !== value ? ` aria-label="${value.replace(/"/g, '&quot;')}"` : ''}>${text}</button>`).join('')}
        </div>
      </div>`).join('');

    const v = current();
    const show = v || m.live.find((x) => matches(x, { ...state, size: null })) || m.open;
    dlg.querySelector('.ill-qa__price').textContent = money(show.price);
    const add = dlg.querySelector('.ill-qa__add');
    add.setAttribute('aria-disabled', String(!v));
    add.textContent = v ? `Add to cart · ${money(v.price)}` : 'Select your size';
  };

  function onPick(e) {
    const b = e.target.closest('.ill-qa__opt');
    if (!b) return;
    const { key, value } = b.dataset;
    state[key] = value;
    const { m } = state;
    if (key !== 'size') {
      if (!m.live.some((v) => matches(v, { ...state, size: null }))) {
        const any = m.live.find((v) => matches(v, { ...state, size: null }, 'fit'));
        if (any) state.fit = m.fitOf(any);
      }
      if (state.size != null && !m.live.some((v) => matches(v, state))) state.size = null;
    }
    dlg.querySelector('.ill-qa__err').hidden = true;
    render();
    const again = dlg.querySelector(`.ill-qa__opt[data-key="${key}"][data-value="${CSS.escape(value)}"]`);
    if (again) again.focus();
  }

  async function onAdd() {
    const add = dlg.querySelector('.ill-qa__add');
    const v = current();
    if (!v) {
      const grp = dlg.querySelector('[data-grp="size"]');
      if (grp) {
        grp.classList.add('is-nudge');
        setTimeout(() => grp.classList.remove('is-nudge'), 1600);
        grp.querySelector('.ill-qa__opt')?.focus();
      }
      return;
    }
    if (add.getAttribute('aria-busy') === 'true') return;
    add.setAttribute('aria-busy', 'true');
    const err = dlg.querySelector('.ill-qa__err');
    err.hidden = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Could not add this size');
      dlg.close();
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart, bubbles: true }));
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
    } catch (e2) {
      err.textContent = e2.message || 'Could not add this size. Please try again.';
      err.hidden = false;
    } finally {
      add.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-ill-qa]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    let m = null;
    try {
      m = build(await getProduct(btn.dataset.illQa));
    } catch (e2) { m = null; }
    btn.removeAttribute('aria-busy');
    if (!m) {
      window.location.assign(btn.dataset.illQaUrl);
      return;
    }
    const d = sheet();
    state = {
      m,
      garment: m.roles.garment >= 0 ? m.val(m.open, m.roles.garment) : null,
      fit: m.fitOf(m.open),
      size: null
    };
    const card = btn.closest('.product-item, .product');
    const img = card && card.querySelector('img');
    const pic = d.querySelector('.ill-qa__img');
    pic.src = img ? (img.currentSrc || img.src) : '';
    pic.hidden = !img;
    d.querySelector('.ill-qa__title').textContent = (btn.getAttribute('aria-label') || '').replace(/^Quick add:\s*/, '');
    d.querySelector('.ill-qa__more').href = btn.dataset.illQaUrl;
    d.querySelector('.ill-qa__err').hidden = true;
    render();
    document.documentElement.classList.add('ill-qa-open');
    d.classList.add('is-entering');
    d.showModal();
    requestAnimationFrame(() => d.classList.remove('is-entering'));
    const first = d.querySelector('[data-grp="size"] .ill-qa__opt');
    if (first) first.focus({ preventScroll: true });
  }, true);
})();
